module.exports = __webpack_public_path__ + "static/img/right.56f44a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/right.png
// module id = 90
// module chunks = 1